import * as o from "react";
import a from "../lib/IconBase.es.js";
import r from "../defs/RocketLaunch.es.js";
const c = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: r }));
c.displayName = "RocketLaunchIcon";
const s = c;
export {
  s as RocketLaunch,
  c as RocketLaunchIcon
};
